export const generatePhoneNumberLink = (number) =>
  `tel:+1${number.replace(/\D/g, '')}`;

export const DEMO_PHONE_NUMBER = '(800) 555-1234';
export const DEMO_PHONE_NUMBER_LINK = generatePhoneNumberLink(
  DEMO_PHONE_NUMBER
);

export const BRIDGEVINE_PHONE_NUMBER = '(888) 394-0560';
export const BRIDGEVINE_PHONE_NUMBER_LINK = generatePhoneNumberLink(
  BRIDGEVINE_PHONE_NUMBER
);
export const BRIDGEVINE_TRANSFER_PHONE_NUMBER = '(844) 649-7058';
export const BRIDGEVINE_NO_OFFER_PHONE_NUMBER = '(844) 649-7060';
export const BRIDGEVINE_TRANSFER_PHONE_NUMBER_LINK = generatePhoneNumberLink(
  BRIDGEVINE_TRANSFER_PHONE_NUMBER
);
export const BRIDGEVINE_NO_OFFER_PHONE_NUMBER_LINK = generatePhoneNumberLink(
  BRIDGEVINE_NO_OFFER_PHONE_NUMBER
);

// This value has a different format because it’s passed in to UHS
export const SHOP_PHONE_NUMBER = '844-647-7950';
export const SHOP_HEADER_PHONE_NUMBER = '(866) 491-2577';
export const SHOP_HEADER_PHONE_NUMBER_LINK = generatePhoneNumberLink(
  SHOP_HEADER_PHONE_NUMBER
);

export const VERIZON_PHONE_NUMBER = '(866) 471-5571';
export const VERIZON_PHONE_NUMBER_LINK = generatePhoneNumberLink(
  VERIZON_PHONE_NUMBER
);

export const ATT_PHONE_NUMBER = '(866) 586-7668';
export const ATT_PHONE_NUMBER_LINK = generatePhoneNumberLink(ATT_PHONE_NUMBER);

export const DUKE_PHONE_NUMBER = '(866) 492-0018';
export const DUKE_PHONE_NUMBER_LINK = generatePhoneNumberLink(
  DUKE_PHONE_NUMBER
);

export const PGE_PHONE_NUMBER = '(866) 492-0266';
export const PGE_PHONE_NUMBER_LINK = generatePhoneNumberLink(PGE_PHONE_NUMBER);

export const MOVING_SPECIALIST = 'Updater moving specialist';
export const HOMEPERKS_MOVING_SPECIALIST = 'HomePerks moving specialist';
export const MINIMUM_SPEED = 'MINIMUM';
export const NORMAL_SPEED = 'NORMAL';
export const MAXIMUM_SPEED = 'MAXIMUM';
export const SPEED_MAP = {
  [MINIMUM_SPEED]: 25,
  [NORMAL_SPEED]: 100,
  [MAXIMUM_SPEED]: 1000,
};

export const PREFERENCES_DEFAULTS = {
  internet: true,
  tv: true,
  phone: false,
};

export const FEATURED_PROVIDER_TYPES = {
  UPDATER: 'updater',
  NONE: 'none',
  EXCLUSIVE: 'exclusive',
  FEATURED: 'featured',
};

export const ANALYTICS_PROVIDER_TYPES = {
  UPDATER: 'updater_featured',
  EXCLUSIVE: 'client_exclusive',
  FEATURED: 'client_featured',
};
